<template lang="pug">
  div(v-if="this.user.role === 'driver'")
    // Buscador de entregas
    div(class="bg-tab" style="position: sticky; top: 0; z-index: 1;")
      b-input-group.pt-2(
        style="justify-content: space-between; padding-left: 15px; padding-right: 15px;"
      )
        b-form-datepicker(
          label-no-date-selected="Desde..."
          v-model="backendFilters.startDate"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          reset-button
          class="col-5"
        )
        h1(style="line-height: 0.8") -
        b-form-datepicker(
          label-no-date-selected="Hasta..."
          v-model="backendFilters.endDate"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          reset-button
          class="col-5"
        )
      b-input-group.pt-2(
        class="mb-3"
      )
        b-input#search-input-delivery(
          placeholder="Buscar Aquí..."
          v-model="backendFilters.search"
          class="ml-2"
        )
        b-input-group-prepend.mr-2(class="input-button-search" @click="applyFilters")
          b-input-group-text(class="icon-search-input")
            .material-icons.icon(class="icon-search") search
      b-tabs(active-nav-item-class="text-uppercase tab-deliverys" content-class="mt-3" justified)
        b-tab(:title="`POR CERRAR (${notClosedCount})`" :active="tabSelected === 'delivery'" @click="tabSelected='delivery'")
        b-tab(:title="`CERRADOS  (${closedCount})`" :active="tabSelected === 'delivered'" @click="tabSelected='delivered'")
    b-container#deliveries-list(fluid="lg")
      p(v-show="deliveries.length !== 0 " class="title-tab") {{ tabSelected === 'delivered' ? 'Envíos Entregados' : 'Lista de Viajes' }}
      p(v-if="Object.entries(deliveriesByCommune).length === 0 && !isLoading" class="text-center") {{ this.search ? 'No se encontraron resultados' : 'No hay entregas' }}
      p(
        v-for="[key, value] of Object.entries(deliveriesByCommune)"
        class="title-tab"
      ) {{ key }}

        b-card(
          v-for="delivery in value"
          :key="delivery.drivInCode"
          :class="delivery.inTransit ? 'mt-4 shadow card-envios position-relative scanned' : 'mt-4 shadow card-envios position-relative not-scanned-in-transit'"
        )
          b-badge(
            :style="getBadgeStyle(delivery)"
            class="custom-badge"
          ) {{ tabSelected === 'delivered' ? getStatusText(delivery.status) : delivery.type }}
          b-badge.tags(pill) {{ delivery.tagsName }}
          .material-icons.icon(class="icon-play" @click="detailtDelivery(delivery)") play_circle_filled
          b-badge.scan-in-transit-badge(v-if="!delivery.inTransit" @click="markAsInTransit(delivery)" pill)
            | Por escanear
            .material-icons(style="font-size: 22px;") qr_code_scanner
          b-badge.scanned-in-transit-badge(v-else @click="markAsDelivered(delivery)" pill)
            | Escaneado
            .material-icons-outlined(style="font-size: 22px;") qr_code_scanner
          p.text-title {{ `#${delivery.numberStore} ${delivery.nameStore}` }}
          b-row.row-between
            p.destinatario-text {{ delivery.finalCustomer }}
          p.text-address {{ delivery.address }}
          p.text-commune {{ delivery.commune }}
          p.mb-1.text-tracking.small-text Observaciones:  {{ delivery.observations ? delivery.observations : '-' }}
          p.mb-1.text-tracking.small-text N° Seguimiento: {{ delivery.drivInCode }}
          p.mb-1.text-tracking.small-text Cantidad de Bultos: {{ delivery.bundleQuantity }}
          p.mb-1.text-tracking.small-text(v-if="tabSelected === 'delivery'") Fecha: {{ formatDate(delivery.date) }}
          p.mb-1.text-tracking.small-text(v-else) Fecha Cierre: {{ formatDeliveryAt(delivery.deliveredAt) }}
          p.mb-1.text-tracking.small-text Cantidad de Intentos: {{ delivery.deliveryAttempts }}
    div.text-center(v-if="isFullList") No hay más entregas
    div.text-center(style="min-height: 50px;")
      b-spinner(v-if="isLoading" label="Spinning" variant="primary")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { io } from 'socket.io-client'
import settings from '../../../settings.js'
import moment from 'moment-timezone'
export default {
  name: 'TabDelivery',
  data () {
    const today = moment.tz('America/Santiago').format('YYYY-MM-DD')
    let startDate = moment().subtract(31, 'days')
    const minDate = moment('2025-05-07')

    if (!moment(startDate).isAfter(minDate)) {
      startDate = minDate
    }

    const startDateFormatted = startDate.format('YYYY-MM-DD')
    return {
      deliveries: [],
      allDeliveries: [],
      closedCount: 0,
      notClosedCount: 0,
      isLoading: false,
      user: null,
      search: '',
      debounceTimer: null,
      tabSelected: '',
      websocketUrl: settings.baseApi.split('api')[0],
      totalDeliveries: 0,
      currentPage: 1,
      pageSize: 30,
      backendFilters: {
        search: '',
        page: 1,
        startDate: startDateFormatted,
        endDate: today
      }
    }
  },
  computed: {
    ...mapGetters(['saveTabSelected']),
    isFullList () {
      if (this.deliveries.length === 0) {
        return false
      }
      return this.deliveries.length >= this.totalDeliveries
    },
    deliveriedList () {
      return this.allDeliveries.filter(delivery => delivery.entregado)
    },
    deliveryList () {
      return this.allDeliveries.filter(delivery => !delivery.entregado)
    },
    filterDeliveries2 () {
      const filteredList = []
      if (this.tabSelected === 'delivered') {
        filteredList.push(...this.deliveriedList)
      } else {
        filteredList.push(...this.deliveryList)
      }
      return this.searchDeliveries(filteredList)
    },
    filterDeliveries () {
      return this.searchDeliveries(this.deliveries)
    },
    numberDelivery () {
      return this.deliveryList.length
    },
    numberDelivered () {
      return this.deliveriedList.length
    },
    deliveriesByCommune () {
      const deliveriesByCommune = {}
      for (const delivery of this.filterDeliveries) {
        const commune = delivery.commune.toUpperCase()
        deliveriesByCommune[commune]
          ? deliveriesByCommune[commune].push({ ...delivery })
          : deliveriesByCommune[commune] = [{ ...delivery }]
      }
      return deliveriesByCommune
    }
  },
  methods: {
    ...mapActions(['getMyDeliveries', 'packageScanning']),
    getStatusText (status) {
      const statusTexts = {
        approved: 'Aprobado',
        partial: 'Parcial',
        rejected: 'Rechazado',
        'in-transit': 'En tránsito'
      }

      return statusTexts[status] || 'Estado desconocido'
    },
    async handleScroll () {
      console.log('Scroll event triggered')
      console.log(this.deliveries.length, this.totalDeliveries)
      // Evitar múltiples solicitudes si ya se está cargando o si no hay más entregas
      if (this.isLoading) return
      if (this.deliveries.length >= this.totalDeliveries) return

      // Obtener las posiciones de scroll y el tamaño de la ventana
      const scrollTop = window.scrollY
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      console.log('scrollTop:', scrollTop)
      console.log('windowHeight:', windowHeight)
      console.log('documentHeight:', documentHeight)
      console.log('scrollTop + windowHeight:', scrollTop + windowHeight)

      // Verificar si el usuario ha llegado al final de la página
      if (scrollTop + windowHeight >= documentHeight - 50) { // Reducir margen a 50px
        console.log('Cargando más entregas...')
        await this.fetchDeliveries2(this.currentPage + 1) // Cargar la siguiente página
      }
    },
    debounce (func, wait) {
      let timeout
      return function (...args) {
        const later = () => {
          clearTimeout(timeout)
          func.apply(this, args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    },
    formatDeliveryAt (dateString) {
      const date = moment(dateString).tz('America/Santiago')
      return date.format('DD-MM-YYYY HH:mm')
    },
    formatDate (dateString) {
      const date = dateString.split('-')
      const day = date[2]
      const month = date[1]
      const year = date[0]
      return `${day}-${month}-${year}`
    },
    applyFilters () {
      this.deliveries = []
      this.currentPage = 1
      this.fetchDeliveries2()
    },
    async fetchCounters () {
      try {
        const params = {
          startDate: this.backendFilters.startDate,
          endDate: this.backendFilters.endDate,
          entregado: true,
          search: this.backendFilters.search.trim(),
          pageSize: 1
        }
        const paramsClosed = {
          ...params,
          entregado: true
        }

        const paramsNotClosed = {
          ...params,
          entregado: false
        }

        const response = await this.$store.dispatch('listDeliveriesByDateAndStatus', { params: paramsClosed })
        const { total: closedCount } = response

        const response2 = await this.$store.dispatch('listDeliveriesByDateAndStatus', { params: paramsNotClosed })
        const { total: notClosedCount } = response2
        this.closedCount = closedCount
        this.notClosedCount = notClosedCount
      } catch (error) {
        console.error('Error fetching counters:', error)
      }
    },
    async fetchDeliveries2 (page = 1) {
      if (this.isLoading) return
      this.isLoading = true // Mostrar indicador de carga
      this.fetchCounters()
      try {
        const params = {
          startDate: this.backendFilters.startDate, // Usar el valor dinámico
          endDate: this.backendFilters.endDate,
          entregado: this.tabSelected === 'delivered',
          search: this.backendFilters.search.trim(),
          page, // Número de página
          pageSize: this.pageSize // Tamaño de la página
        }
        const response = await this.$store.dispatch('listDeliveriesByDateAndStatus', { params })
        const { deliveries, total } = response
        console.log(total)
        if (page === 1) {
          this.deliveries = deliveries
        } else {
          this.deliveries = [...this.deliveries, ...deliveries]
        }
        this.totalDeliveries = total
        this.currentPage = page
      } catch (error) {
        console.error('Error fetching deliveries:', error)
      } finally {
        this.isLoading = false // Ocultar indicador de carga
      }
    },
    getBadgeStyle (delivery) {
      const status = delivery.status
      if (status === 'approved') {
        return {
          backgroundColor: 'var(--status-approved)',
          color: 'white'
        }
      } else if (status === 'rejected') {
        return {
          backgroundColor: 'var(--status-rejected)',
          color: 'white'
        }
      } else if (status === 'in-transit') {
        return {
          backgroundColor: 'var(--status-in-transit)',
          color: 'white'
        }
      } else if (status === 'partial') {
        return {
          backgroundColor: 'var(--status-partial)',
          color: 'white'
        }
      } else {
        return {
          backgroundColor: '#F7B232',
          color: 'white'
        }
      }
    },
    debouncedSearch () {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.searchDeliveries()
      }, 500)
    },
    searchDeliveries (deliveries) {
      const searchTerm = this.search.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

      if (searchTerm === '') {
        return [...deliveries]
      }

      return deliveries.filter((delivery) => {
        const formattedDrivInCode = delivery.drivInCode ? delivery.drivInCode.toLowerCase() : ''
        const formattedAddress = delivery.address ? delivery.address.toLowerCase() : ''
        const formattedFinalCustomer = delivery.finalCustomer ? delivery.finalCustomer.toLowerCase() : ''
        const formattedStore = delivery.nameStore ? delivery.nameStore.toLowerCase() : ''
        const formattedCommune = delivery.commune ? delivery.commune.toLowerCase() : ''
        const formattedObservations = delivery.observations ? delivery.observations.toLowerCase() : ''
        const formattedTags = delivery.tagsName ? delivery.tagsName.toLowerCase() : ''

        const fullText = [
          formattedStore,
          formattedFinalCustomer,
          formattedAddress,
          formattedDrivInCode,
          formattedCommune,
          formattedObservations,
          formattedTags
        ].join(' ').normalize('NFD').replace(/[\u0300-\u036f]/g, '') // remove accents

        return fullText.includes(searchTerm)
      })
    },
    async fetchDeliveries () {
      if (this.isLoading) return
      this.isLoading = true
      try {
        const response = await this.getMyDeliveries()
        if (response.status === 200) {
          this.allDeliveries = response.data
        }
      } catch (error) {
        console.error('Error al buscar', error)
      } finally {
        this.isLoading = false
      }
    },
    detailtDelivery (delivery) {
      this.$store.commit('SET_DELIVERY_SELECTED', delivery)
      this.$router.push(`/mis-envios/${delivery.id}`)
    },
    async initWebsockets () {
      console.log('conectando a websocket')
      this.socket = io(this.websocketUrl)

      this.socket.on('delivery:updated', (data) => {
        console.log('Envío actualizado', data || '')
        if (this.user.role === 'driver') {
          if (data.update.drivers?.includes(this.user.id)) {
            // this.fetchDeliveries({ params: this.tabSelected || 'delivery' })
          }
        }
      })
    },
    async markAsInTransit (item) {
      const ok = await this.$bvModal.msgBoxConfirm('¿Estás seguro de escanear de forma manual el envío?', {
        title: 'Confirmación',
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar',
        centered: true
      })
      if (ok) {
        await this.packageScanning({ codes: [item.drivInCode], scan_type: 'ruta-conductor', mode: 'manual' })
        item.inTransit = true
        this.$bvToast.toast(`Envío ${item.drivInCode} escaneado con éxito!`, {
          title: 'Éxito',
          variant: 'success',
          autoHideDelay: 5000
        })
        this.$forceUpdate()
      }
    }
  },
  watch: {
    tabSelected (val) {
      this.$store.commit('SET_TAB_SELECTED', val)
      this.deliveries = []
      this.currentPage = 1
      this.fetchDeliveries2()
    },
    backendFilters: {
      handler () {
        if (this.backendFilters.startDate && this.backendFilters.endDate) {
          this.debouncedApplyFilters()
        }
      },
      deep: true
    }
  },
  mounted () {
    this.debouncedHandleScroll = this.debounce(this.handleScroll, 300) // Debounce de 200ms
    this.debouncedApplyFilters = this.debounce(this.applyFilters, 200) // Debounce de 200ms
    window.addEventListener('scroll', this.debouncedHandleScroll)
  },
  created () {
    const user = JSON.parse(localStorage.getItem('user')).user
    this.user = user
    this.tabSelected = this.saveTabSelected || 'delivery'
    // this.fetchDeliveries()
    this.initWebsockets()
  },
  destroyed () {
    if (!this.socket) return
    this.socket.disconnect()
    console.log('conexión a websocket terminada')

    window.removeEventListener('scroll', this.debouncedHandleScroll)
  }
}
</script>
<style lang="scss" scoped>
#search-input-delivery::placeholder {
  color: #C3C3C3;
}
#search-input-delivery {
  border: none ;
}
.icon-search {
  color: #C3C3C3;
}
.icon-search-input{
  border: none;
  background-color: transparent;
}
.title-tab{
  color: #4F4F4F;
  font-weight: 700;
  font-size: 18px;
  font-family: 'Source Sans Pro', sans-serif;

}
.bg-tab {
  background-color: #FFFFFF;
}
.tags {
  background-color: #FFE45F;
  color: #264848;
  margin-block: auto;
  margin-top: 10px;
  font-size: 16px;
  padding: 9px;
  font-weight: 600;
  width: 100px;
  position: absolute;
  right: 15px;
  top: 40px;
}
.row-between {
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
}
.input-button-search{
  background-color: #071217;
}
.not-scanned-in-transit{
  background-color: #afafaf;
}

.scan-in-transit-badge{
  position: absolute;
  bottom: 15px;
  right: 15px;
  display: flex;
  align-items: center;
  gap: 5px;
  .material-icons{
    font-size: 22px;
  }
}
.scanned-in-transit-badge{
  position: absolute;
  bottom: 15px;
  right: 15px;
  display: flex;
  align-items: center;
  gap: 5px;
  .material-icons{
    font-size: 22px;
  }
}
</style>
